import React from "react";
import { Modal, Button } from "@deere/ux.uxframe-react";
import { Typography } from "@deere/fuel-react";
import { ERR_DOC_NOT_FOUND } from "../../utils/errorLiterals";
import { t } from "i18next";
import { HELP_DOC_PDF_NAME } from "../../utils/surveyLiterals";

export const ModalDocument = ({ showModal, setShowModal, labelBtnPrimary, titleModal, iFrameUrl }) => {
  const pdfDownload = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', HELP_DOC_PDF_NAME);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }

  return (
    <Modal size="lg" show={showModal} backdrop="static">
      <Modal.Header>
        <Modal.Title>{titleModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-hidden">
        {iFrameUrl ? (
          <iframe src={`${iFrameUrl}#toolbar=0`} width={"100%"} height={"300"} />
        ) : (
          <Typography color="error" gutterBottom>
            {ERR_DOC_NOT_FOUND}
          </Typography>
        )}
      </Modal.Body>
      <Modal.Footer>
      <Button type="submit" variant="secondary" onClick={() => pdfDownload(iFrameUrl)}>
        {t('btn_download')}
        </Button>
        <Button type="submit" variant="primary" onClick={() => setShowModal(false)}>
          {labelBtnPrimary}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
